import React, { createContext, useContext, useState, ReactNode } from 'react';

type FullscreenState = {
    open: boolean;
    type: string | null;
};

type SharedContextType = {
    fullscreen: FullscreenState;
    setFullscreen: React.Dispatch<React.SetStateAction<FullscreenState>>;
    selectedInfoYear: number;
    setSelectedInfoYear: React.Dispatch<React.SetStateAction<number>>;
    years: number[];
};

const defaultFullscreen: FullscreenState = {
    open: false,
    type: null,
};

const SharedContext = createContext<SharedContextType | undefined>(undefined);

export const SharedProvider = ({ children }: { children: ReactNode }) => {
    const [fullscreen, setFullscreen] = useState<FullscreenState>(defaultFullscreen);
    const [selectedInfoYear, setSelectedInfoYear] = useState<number>(2024);
    const years = [2024];

    return (
        <SharedContext.Provider value={{ fullscreen, setFullscreen, selectedInfoYear, setSelectedInfoYear, years }}>
            {children}
        </SharedContext.Provider>
    );
};

export const useShared = () => {
    const context = useContext(SharedContext);
    if (!context) {
        throw new Error('useShared must be used within a SharedProvider');
    }
    return context;
};